import { createSelector } from "reselect"
import Rock from "../../assets/images/icon-rock.svg"
import Scissors from "../../assets/images/icon-scissors.svg"
import Paper from "../../assets/images/icon-paper.svg"
const game = state=>state.game


export const  choiceSelector = createSelector([game],(game)=>{
    switch(game.selected){
        case "rock":
            return({
                variant : game.selected,
                image : Rock
            })
        case "scissors":
            return({
                variant : game.selected,
                image : Scissors
            })
        case "paper":
            return({
                variant : game.selected,
                image : Paper
            })
        default : return null;
    }
})
export const  computerchoiceSelector = createSelector([game],(game)=>{
    switch(game.computer){
        case 0:
            return({
                variant : "rock",
                image : Rock
            })
        case 1:
            return({
                variant : "scissors",
                image : Scissors
            })
        case 2:
            return({
                variant : "paper",
                image : Paper
            })
        default : return null;
    }
})

export const resultSelector = createSelector([game],(game)=>game.result)
export const scoreSelector = createSelector([game],(game)=>game.currentScore)